module.exports = {
      id: "sale-usage",
      viewBox: "0 0 26 20",
      url: __webpack_public_path__ + "sprite-d2a4e8aaeb47684d6d07571fc646b0db.svg#sale",
      toString: function () {
        return this.url;
      }
    }